module.exports = __webpack_public_path__ + "static/media/peterArt6.d11de6ee.jpg";